export default "__VITE_ASSET__BxMKYWOJ__"